<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      @click.self="emit('close')"
    >
      <div
        class="relative w-full max-w-[669px] rounded-[20px] border border-tertiary bg-secondary p-8 shadow-2xl"
      >
        <h2 class="mb-6 border-b border-tertiary pb-4 text-2xl font-bold text-accent">
          Warnung
        </h2>

        <div class="mb-6 space-y-6 rounded-[20px] border border-tertiary bg-primary p-6">
          <p class="text-base text-text-main">
            Soll der Code wirklich auf den Ausgangszustand zurückgesetzt werden?
          </p>
          <p class="text-sm font-bold text-accent">
            Alle von Dir gemachten Änderungen werden damit verworfen.
          </p>
        </div>

        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            class="cursor-pointer rounded-standard bg-accent px-8 py-2 text-sm font-semibold text-text-main shadow-sm transition-all duration-150 hover:brightness-110"
            @click="confirm"
          >
            OK
          </button>

          <button
            type="button"
            class="cursor-pointer rounded-standard border border-tertiary bg-primary px-6 py-2 text-sm font-semibold text-text-main transition-colors duration-150 hover:bg-primary/80"
            @click="emit('close')"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'confirm'): void
}>()

function confirm() {
  emit('confirm')
  emit('close')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
